/**
 * UI-дескриптор модуля ЧЗ для админки ядра (ARCH-TASK-65.12.7).
 */
import type { ModuleUiDescriptor } from '@core/modules/types'
import { db } from '@core/db/db'
import { CzModuleSection } from './CzModuleSection'

export { CzModuleSection }

/** Ключ meta принадлежит модулю, а не ядру. */
const META_MODULE_CZ_ENABLED = 'module_cz_enabled'

export const czModuleUi: ModuleUiDescriptor = {
  id: 'ru-cz',
  title: 'Честный Знак',
  enabledMetaKey: META_MODULE_CZ_ENABLED,
  order: 10,
  applyEnabled: (enabled, core) => core.marking?.setEnabled(enabled),
  isEnabled: (core) => core.marking?.isEnabled() ?? false,
  canDisable: async () => {
    const held = await db.receipts.where('status').equals('marking_review').count()
    if (held === 0) return null
    return (
      `Нельзя выключить ЧЗ: ${held} чек(ов) ждут решения по маркировке. ` +
      'Сначала одобрите или отмените их.'
    )
  },
  Component: CzModuleSection
}
